<div class="flex flex-column w-full">
  <div #talkjsContainer style="height: 600px">
    <span role="status" aria-label="Φόρτωση μηνυμάτων...">
      <i
        class="pi pi-spin pi-spinner text-center w-full"
        style="font-size: 2rem"
        aria-hidden="true"
      ></i>
    </span>
  </div>
</div>
